import React from "react";
import { Form, Spinner } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { Formik } from "formik";
import { editCategorySchema } from "../validation/editCategory";
import {
  useTemplateCategoryDeleteMutation,
  useTemplateCategoryEditMutation,
  useTemplateCategoryListQuery,
  useTemplateCategoryShowQuery,
} from "../../../graphql/templateCategory.hooks";
import { StyledInput } from "../../../components/inputs/styledInput";

export const EditTemplateCategory = () => {
  const navigate = useNavigate();
  const { categoryId } = useParams();
  const [editCategory, { loading: editLoading }] =
    useTemplateCategoryEditMutation();
  const [deleteCategory, { loading: deleteLoading }] =
    useTemplateCategoryDeleteMutation();
  const {
    data: category,
    loading: categoryLoading,
    refetch: showCategoryRefetch,
  } = useTemplateCategoryShowQuery({
    variables: { templateCategory: +categoryId },
  });
  const { refetch: categoryRefetch } = useTemplateCategoryListQuery();

  const initialValues = {
    title: category?.templateCategoryShow.title || "",
    position: category?.templateCategoryShow.position || 0,
  };

  const backToList = () => {
    navigate("/template/category");
  };

  const tryDeleteCategory = async () => {
    try {
      const { data } = await deleteCategory({
        variables: { templateCategory: +categoryId },
      });
      if (data.templateCategoryDelete) {
        categoryRefetch();
        backToList();
      }
    } catch (err) {
      console.error(err);
    }
  };

  const tryUpdateCategory = async (values: any) => {
    try {
      const { data } = await editCategory({
        variables: {
          templateCategory: +categoryId,
          title: values.title,
          position: values.position,
        },
      });
      if (data.templateCategoryEdit.id) {
        showCategoryRefetch();
        categoryRefetch();
        backToList();
      }
    } catch (err) {
      console.error(err);
    }
  };

  if (categoryLoading) {
    return (
      <div className="d-flex align-items-center justify-content-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className="mb-4">
          <h1>Edit Template Category</h1>
        </div>
      </div>
      <div className="g-4 py-5 d-flex flex-column justify-content-center align-items-center bg-white rounded">
        <div className="d-flex flex-column flex-md-row justify-content-between col-11 col-md-8">
          <Formik
            initialValues={initialValues}
            validationSchema={editCategorySchema}
            onSubmit={tryUpdateCategory}
            enableReinitialize
          >
            {({ handleSubmit, touched, errors }) => (
              <Form className="w-100">
                <div className="form-floating mb-3 w-100">
                  <StyledInput
                    name="title"
                    label="Title"
                    error={!!(touched.title && errors.title)}
                  />
                </div>
                <div className="form-floating mb-3 w-100">
                  <StyledInput
                    name="position"
                    type="number"
                    label="Position"
                    className="numberForm"
                    error={!!(touched.position && errors.position)}
                  />
                </div>
                <div className="d-flex flex-column flex-md-row justify-content-between col-12">
                  <button
                    onClick={backToList}
                    className="btn btn-primary text-white col-12 col-md-3 me-md-2 mb-2 mb-md-0"
                  >
                    Back To List
                  </button>
                  <button
                    type="button"
                    disabled={editLoading}
                    onClick={() => handleSubmit()}
                    className="btn btn-primary text-white col-12 col-md-3 me-md-2 mb-2 mb-md-0"
                  >
                    Update
                    {editLoading && (
                      <Spinner
                        animation="border"
                        role="status"
                        className="ms-2"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    )}
                  </button>
                  <button
                    type="button"
                    disabled={deleteLoading}
                    onClick={tryDeleteCategory}
                    className="btn danger-hover btn-outline-danger danger-hover text-danger col-12 col-md-3 mb-2 mb-md-0"
                  >
                    Delete
                    {deleteLoading && (
                      <Spinner
                        animation="border"
                        role="status"
                        className="ms-2"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    )}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};
